import { atom } from 'recoil';
import { Coupon } from '~/types/coupon';

const coupon = atom<Coupon | null>({
  key: 'coupon',
  default: null,
});

export default coupon;
